// §25.10 / §9.1 — Wayfarer as an in-process app. Gated (D-200); manifest only (D-247), so the
// world, the eight floors, the thirteen enemies and the renderer all ride the lazy chunk (§24.12).
import type { InProcessApp } from '@hangar/shared';
import { createLazyApp } from '@/gamekit/lazy';

export const wayfarerApp: InProcessApp = createLazyApp({
  app: {
    id: 'wayfarer',
    name: 'Wayfarer',
    icon: { glyph: 'swords', hue: 275 },
    keywords: ['rpg', 'jrpg', 'quest', 'adventure', 'dungeon', 'game', 'arcade'],
    category: 'Arcade',
    // §29.1 (D-369) — the sub-group header this title sits under in the launcher and the Store.
    group: 'Action',
    requiresAuth: true,
    // 25 × 15 tiles plus the status panel, letterboxed (D-229). How much of the map you can see is
    // a design decision — a window that changed it would change how legible every dungeon is.
    window: { width: 880, height: 640, minWidth: 560, minHeight: 460, multiWindow: false },
    jumpList: [{ id: 'new-game', label: 'New game' }],
  },
  load: () => import('./Wayfarer'),
});
